<script>
	import {sQuery as sq} from './sq.js';
	import {update, sync_scroll, check_tab} from './Sq_editor.js';
	import Core from './Core.svelte'

	let c = `<p id="p1">element1<\/p>
<p id="p2">element2<\/p>
<p id="p3">element3<\/p>

<script src="./squery.min.js"><\/script>
<script>
sq(()=>{
	sq('p').css('font-size', '22px')
	sq('p').on('click', function(){
		sq(this).css('background', 'yellow')
	})
	sq('p[id="p2"]').on('mouseover', function(){
		sq(this).css({
			border: '1px dotted blue',
			textShadow: '2px 2px 8px #44f'
		})
	}).on('mouseout', function(){
		sq(this).css({
			border: 'none',
			textShadow: 'none'
		})
	})
})
<\/script>
`
	let loadProc = function(){
		console.log('load 2')
		sq('body').hide().fadeIn(400)

		sq('#editing').on('change', function(){
			//console.log('change')
			let code = sq('#editing').val().replace(/'/g,"\\'").replace(/\n/g,"\\n")
			//document.getElementById('idResult').contentWindow.document.write(code);
			var myIFrame = document.getElementById('idResult');
			myIFrame.src="javascript:'"+code+"'";
		})
		sq('#editing').on('input', function(){
			//console.log('input')
			update(this.value)
			sync_scroll(this)
		})
		sq('#editing').on('keydown', function(e){
			//console.log('keydown')
			switch(e.keyCode){
				case 9:
					window.bTab = true
					e.preventDefault()
                    return false;
                case 16:
                    window.bShift = true
					e.preventDefault()
                    return false;
                case 17:
					window.bCtrl = true
					e.preventDefault()
					return false;
            }
			//
		})
		sq('#editing').on('keyup', function(e){
			//console.log('keyup' )
			check_tab(this, e)
			switch(e.keyCode){
				case 9:
					return false
                case 16:
                    window.bShift = false
                    return false
                case 17:
					window.bCtrl = false
					return false
            }
		})
		sq('#editing').on('scroll', function(e){
			sync_scroll(this)
		})

		sq('#editing').val(c).trg('input').trg('change')
		sq('#idDoc').css({
			'width': '100%',
			'max-width': '100%'
		})
		sq('.cF').contains('editor').addClass('active')
	}

	if (sq().isPageLoaded())
	{
		console.log('spa loaded')
		setTimeout(() => {
			loadProc()
		}, 1);
	}
	sq(()=>{
		console.log('loaded')
		loadProc()
	})
</script>

<Core>
<link rel="preconnect" href="https://fonts.googleapis.com">
<link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
<link href="https://fonts.googleapis.com/css2?family=Source+Code+Pro:wght@300&display=swap" rel="stylesheet">

	<link rel="stylesheet" href="./Docs.css">
	<link rel="stylesheet" href="./Sq_editor.css">
	<h1>sQuery Online Editor</h1>
	<section class="cCodeCont">
		<div class="cCodeSpace">
			<textarea placeholder="Enter HTML Source Code" id="editing" spellcheck="false"></textarea>
			<pre id="highlighting" aria-hidden="true">
				<code class="language-html" id="highlighting-content"></code>
			</pre>
		</div>

		<!--textarea id="idCode" contenteditable="true"></textarea-->
		<iframe id="idResult" title="editor"></iframe>
	</section>	
</Core>

<style>
	h1 {
		font-size: 2em;
		font-weight: 100;
	}
	.cCodeSpace, #idResult {
		width: calc(50% - 10px);
		max-width: 1500px;
		border: 2px solid #afe5ff;
	}
	.cCodeSpace {
		border: 2px solid #000;
	}
	@media (max-width: 1000px) {
		.cCodeSpace, #idResult {
			margin: 0;
		}
	}

	@media (max-width: 840px) {
		.cCodeSpace, #idResult {
			width: 100%;
			margin: 0;
		}
		#idResult {
			margin-top: 4px;
		}
	}
</style>